import { FC, ReactNode } from 'react';
import type { Stripe, StripeElementsOptions } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { colors } from 'dibs-sassy/exports/colors';
import { spacing } from 'dibs-sassy/exports/spacing';
import { bodyFontSize } from 'dibs-sassy/exports/fonts';

type Props = {
    stripe: Promise<Stripe> | null;
    children: ReactNode;
    paymentMethods: string[];
};

export const PaymentMethodSelectStripeElements: FC<Props> = props => {
    const { stripe, paymentMethods, children } = props;

    if (!paymentMethods) {
        return <>{children}</>;
    }

    const options: StripeElementsOptions = {
        paymentMethodTypes: paymentMethods,
        mode: 'setup',
        fonts: [
            {
                family: 'Proxima Nova',
                src: 'url(https://a.1stdibscdn.com/dist/fonts/ProximaNova/ProximaNova-Light.woff)',
                weight: '400',
            },
            {
                family: 'Proxima Nova',
                src: 'url(https://a.1stdibscdn.com/dist/fonts/ProximaNova/ProximaNova-Sbold.woff)',
                weight: '600',
            },
        ],
        appearance: {
            theme: 'stripe',
            variables: {
                borderRadius: '0px',
                colorDanger: colors.sassyColorAlertPrimary,
                colorText: colors.sassyColorNoir,
                colorPrimary: colors.sassyColorNoir,
                fontFamily: '"Proxima Nova", "Helvetica Neue", "helvetica", "arial", "sans-serif"',
                fontWeightNormal: '400',
                fontWeightBold: '600',
                fontSizeBase: bodyFontSize.medium,
                fontSizeXs: bodyFontSize.medium,
            },
            rules: {
                '.AccordionItem': {
                    boxShadow: 'none',
                    paddingLeft: spacing.sassySpacingSmall,
                    paddingRight: spacing.sassySpacingSmall,
                },
            },
        },
        // @ts-ignore
        paymentMethodOptions: {
            us_bank_account: {
                verification_method: 'instant',
            },
        },
    };

    return (
        <Elements stripe={stripe} options={options}>
            {children}
        </Elements>
    );
};
